const initUomData = {
  
}


export function uomData(
  state = initUomData,
  action
) {
  switch (action.type) {
    case "UOM_FETCH_DATA_SUCCESS":
      return action.dataUom;
    default:
      return state;
  }
}
